import CompanyEdit from './CompanyEdit'

export default [
  {
    path: '/company/:company_id/edit',
    name: 'CompanyEdit',
    component: CompanyEdit,
    meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Company Edit'}
  }
]


// WEBPACK FOOTER //
// ./src/pages/company/router.js